import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTypeOfService } from "./hooks/useTypeOfService";
import { TypeOfServiceCard } from "./TypeOfServiceCard";
import { quoteCreateActions } from "../../../../../../../../redux/features/quotes/quote-create-advanced";
import { QueryState } from "../../../../../../../shared/components/query-states/GlobalQueryState";

export const TypeOfService = ({ categoryType, selected }) => {
  const dispatch = useDispatch();
  const { setService } = quoteCreateActions;

  const typeOfServiceQuery = useTypeOfService({ categoryType });
  const services = typeOfServiceQuery.data?.items || [];

  <QueryState isLoading={typeOfServiceQuery.isLoading} isError={!!typeOfServiceQuery.error} serviceName="Type of Service" />;

  const handleSelectService = (service) => {
    dispatch(setService(service));
  };

  return (
    <Grid container rowSpacing={3} columnSpacing={2} sx={{ maxWidth: "700px", margin: "0 auto", marginTop: "-20px" }}>
      {services.map((service) => (
        <Grid item xs={12} sm={6} md={4} key={service.uid} sx={{ display: "flex", justifyContent: "center" }}>
          <TypeOfServiceCard service={service} selected={selected} onSelect={handleSelectService} />
        </Grid>
      ))}
    </Grid>
  );
};
